import React from 'react';
import './speaker.css'; 
export default function KeynoteSpeakers({ PNG }) {
  return (
    <main className="keynote-speakers-page">
      {/* ===== Background layers ===== */}
      {/* <div className="background-layers">
        <div className="background-gradient" />
        <div 
          className="background-image" 
          style={{ backgroundImage: `url(${PNG.bg})` }} 
        />
      </div> */}

      <section className="speaker-section">
        <div className="speaker-container">
          {/* ===== Speaker Image ===== */}
          <div className="speaker-image-wrapper">
            <div className="speaker-image-group">
              <img
                src={PNG.Swati}
                alt="Prof. Swati Patankar"
                className="speaker-image"
              />
              <div className="speaker-image-overlay"></div>
            </div>
          </div>

          {/* ===== Speaker Info ===== */}
          <div className="speaker-info-content">
            <h2 className="speaker-name">
              Prof. Swati Patankar
            </h2>

            <p className="speaker-title">
              Professor, Department of Biosciences &amp; Bioengineering, IIT Bombay
            </p>

            <hr className="divider" />

            <p className="speaker-bio">
              Prof. Swati Patankar is a distinguished faculty member at IIT Bombay,
              renowned for her pioneering research in molecular parasitology and
              interdisciplinary biological sciences. She is currently the faculty nominee on the Board of Governors of IIT Bombay. She is an independent director on the Board of IPCA Laboratories and a member of the Executive Committee of Nehru Science&nbsp;Centre,&nbsp;Mumbai.
            </p>

            {/* ===== Keynote Focus Box ===== */}
            <div className="keynote-focus-box">
              <div className="keynote-accent-bar" aria-hidden="true" />
              <h3 className="keynote-title-heading">
                Title of the Talk
              </h3>
              <p className="keynote-title">
                <span className="keynote-title-highlight">
                  Women Faculty at IITs:
                </span>{" "}
                Challenges and Ways Forward
              </p>
            </div>

            {/* ===== Closing Note ===== */}
            <p className="closing-note">
              This keynote is part of the Inaugural{" "}
              <span className="closing-note-highlight">
                IIT Women Faculty Meet
              </span>{" "}
              hosted at IIT Delhi — a collaborative initiative aimed at empowering
              women educators through dialogue, mentorship, and leadership.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}